// https://element-plus.org/zh-CN/
// import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

import '../../assets/main.css'
import '../../util/rem'
import 'animate.css';

import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import i18n from './i18n'; // Import the i18n configuration
// import * as Sentry from "@sentry/vue";

// import function to register Swiper custom elements
import { register } from 'swiper/element/bundle';
// register Swiper custom elements
register();
import { store } from './store';

const app = createApp(App)

// https://github.com/amfe/lib-flexible
// import 'amfe-flexible'

// 调试器
if (import.meta.env.DEV) {
    import('vconsole').then(({ default: VConsole }) => {
        new VConsole();
    });
}

// cookies的使用
import { xhSet, xhGet } from '@/util/xhCookie'
import { lang } from "@/util/base";

// 全部变量都存储这里
const existingCookies = xhGet("XH-WEB");

// 如果 cookies.get("XH-WEB") 返回 undefined，则设置一个默认的初始值
const initialCookies = {
    ...xhGet("XH-WEB"),
    // 初始化页面语言
    page_lang: existingCookies?.page_lang || lang(),
    fb_lang: existingCookies?.fb_lang || lang(),
};
xhSet("XH-WEB", initialCookies);

import { loadSdk } from "@/util/loadSdk";
if (xhGet("XH-WEB")?.fb_lang) {
    loadSdk("fb", xhGet("XH-WEB").fb_lang);
}

import { Fingerprint } from "xhwebtool";
// 不存在设备指纹时，写入作为设备ID，写入后除非用户手动删除，否则不改变
if (!localStorage.getItem('fingerprint')) {
    Fingerprint.fingerprint().then((res) => {
        localStorage.setItem('fingerprint', res);
    });
}

// if (!import.meta.env.DEV) {

//     Sentry.init({
//         app,
//         dsn: "https://35add2956d7acfc42f1f9c682b4ec850@o577525.ingest.us.sentry.io/4506987994546176",
//         integrations: [
//             Sentry.browserTracingIntegration({ router }),
//             Sentry.replayIntegration(),
//         ],

//         // Set tracesSampleRate to 1.0 to capture 100%
//         // of transactions for performance monitoring.
//         // We recommend adjusting this value in production
//         tracesSampleRate: 1.0,

//         // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
//         tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],

//         // Capture Replay for 10% of all sessions,
//         // plus for 100% of sessions with an error
//         replaysSessionSampleRate: 0.1,
//         replaysOnErrorSampleRate: 1.0,
//     });
// }

// app.use(ElementPlus)
app.use(store)
app.use(router)
app.use(i18n)
// app.config.globalProperties.$message = ElMessage; // 使用 ElMessage 组件
app.mount('#app')
